<!-- Page Header -->
 
<section class="cuspage-hero">
    <div class="cuspage-hero__bg"></div>
    <div class="container">
        <div class="cuspage-hero__content">
             <span class="cuspage-hero__tagline" style="display:none;">
                <i class="icofont-justice-hammer"></i>
                {{ 'plainte_tagline' | translate }}
            </span>
            <h1 class="cuspage-hero__title">{{ 'plainte_titre' | translate }}</h1>
            <p class="cuspage-hero__sub">{{ 'plainte_sous_titre' | translate }} </p>  
        </div>
    </div>
</section>

<!-- Form Section -->
<section class="arp-form-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-9">

        <!-- ── SUCCESS ── -->
        <div *ngIf="submitted" class="arp-success wow fadeInUp">
          <div class="arp-success__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M9 12l2 2 4-4M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>{{ 'plainte_succes_titre' | translate }}</h3>
          <p>{{ 'plainte_succes_msg' | translate }}</p>
          <div *ngIf="reference" class="arp-ref-badge">
            <span class="arp-ref-label">{{ 'plainte_reference' | translate }}</span>
            <span class="arp-ref-num">{{ reference }}</span>
          </div>
          <div class="arp-success__actions">
            <button class="careox-btn" (click)="reset()">
              <span>{{ 'plainte_nouvelle' | translate }}</span>
            </button>
            <a routerLink="/" class="careox-btn careox-btn--ghost">
              <span>{{ 'accueil' | translate }}</span>
            </a>
          </div>
        </div>

        <!-- ── FORM ── -->
        <div *ngIf="!submitted">
          <div class="sec-title wow fadeInUp" data-wow-delay="100ms" style="display:none;">
            <span class="sec-title__tagline">{{ 'plainte_tagline' | translate }}</span>
            <h3 class="sec-title__title">{{ 'plainte_titre' | translate }}</h3>
            <p class="sec-title__text">{{ 'plainte_sous_titre' | translate }}</p>
          </div>

          <form class="arp-form wow fadeInUp" data-wow-delay="200ms" (ngSubmit)="onSubmit()" novalidate>

            <!-- Error banner -->
            <div *ngIf="error" class="arp-alert-error">{{ error }}</div>

            <!-- Section: Informations du plaignant -->
            <div class="arp-form__section">
              <h5 class="arp-form__section-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" stroke-linecap="round"/>
                </svg>
                {{ 'plainte_section_plaignant' | translate }}
              </h5>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group" [class.has-error]="isInvalid('name')">
                    <label class="arp-label">{{ 'plainte_nom' | translate }} <span class="req">*</span></label>
                    <input type="text" class="form-control arp-input"
                      [(ngModel)]="form.name" name="name"
                      (blur)="touch('name')"
                      [placeholder]="'plainte_nom_ph' | translate">
                    <span *ngIf="isInvalid('name')" class="arp-err">{{ 'plainte_nom_requis' | translate }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group" [class.has-error]="isInvalid('phone')">
                    <label class="arp-label">{{ 'plainte_telephone' | translate }} <span class="req">*</span></label>
                    <input type="tel" class="form-control arp-input"
                      [(ngModel)]="form.phone" name="phone"
                      (blur)="touch('phone')"
                      [placeholder]="'plainte_tel_ph' | translate">
                    <span *ngIf="isInvalid('phone')" class="arp-err">{{ 'plainte_tel_requis' | translate }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group" [class.has-error]="isInvalid('email')">
                    <label class="arp-label">{{ 'plainte_email' | translate }} <span class="req">*</span></label>
                    <input type="email" class="form-control arp-input"
                      [(ngModel)]="form.email" name="email"
                      (blur)="touch('email')"
                      [placeholder]="'plainte_email_ph' | translate">
                    <span *ngIf="isInvalid('email')" class="arp-err">{{ 'plainte_email_requis' | translate }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group" [class.has-error]="isInvalid('address')">
                    <label class="arp-label">{{ 'plainte_adresse' | translate }} <span class="req">*</span></label>
                    <input type="text" class="form-control arp-input"
                      [(ngModel)]="form.address" name="address"
                      (blur)="touch('address')"
                      [placeholder]="'plainte_adresse_ph' | translate">
                    <span *ngIf="isInvalid('address')" class="arp-err">{{ 'plainte_adresse_requise' | translate }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group" [class.has-error]="isInvalid('complaint_type')">
                    <label class="arp-label">{{ 'plainte_type' | translate }} <span class="req">*</span></label>
                    <select class="form-control arp-input"
                      [(ngModel)]="form.complaint_type" name="complaint_type"
                      (blur)="touch('complaint_type')">
                      <option value="">{{ 'plainte_type_choisir' | translate }}</option>
                      <option *ngFor="let t of complaintTypes" [value]="t.value">{{ t.label | translate }}</option>
                    </select>
                    <span *ngIf="isInvalid('complaint_type')" class="arp-err">{{ 'plainte_type_requis' | translate }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="arp-label">{{ 'plainte_priorite' | translate }}</label>
                    <div class="arp-priority-row">
                      <label *ngFor="let p of priorityLevels" class="arp-priority-opt" [class.active]="form.priority === p.value">
                        <input type="radio" [(ngModel)]="form.priority" name="priority" [value]="p.value">
                        <span [class]="'arp-priority-chip ' + p.css">{{ p.label | translate }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section: Détails de la plainte -->
            <div class="arp-form__section">
              <h5 class="arp-form__section-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke-linecap="round"/>
                  <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke-linecap="round"/>
                </svg>
                {{ 'plainte_section_details' | translate }}
              </h5>

              <div class="form-group" [class.has-error]="isInvalid('subject')">
                <label class="arp-label">{{ 'plainte_objet' | translate }} <span class="req">*</span></label>
                <input type="text" class="form-control arp-input"
                  [(ngModel)]="form.subject" name="subject"
                  (blur)="touch('subject')"
                  [placeholder]="'plainte_objet_ph' | translate">
                <span *ngIf="isInvalid('subject')" class="arp-err">{{ 'plainte_objet_requis' | translate }}</span>
              </div>

              <div class="form-group" [class.has-error]="isInvalid('description')">
                <label class="arp-label">{{ 'plainte_description' | translate }} <span class="req">*</span></label>
                <textarea class="form-control arp-input arp-textarea"
                  [(ngModel)]="form.description" name="description"
                  rows="5" (blur)="touch('description')"
                  [placeholder]="'plainte_description_ph' | translate"></textarea>
                <span *ngIf="isInvalid('description')" class="arp-err">{{ 'plainte_description_requise' | translate }}</span>
              </div>
            </div>

            <!-- Section: Pièces jointes -->
            <div class="arp-form__section">
              <h5 class="arp-form__section-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" stroke-linecap="round"/>
                </svg>
                {{ 'plainte_preuves_titre' | translate }}
              </h5>

              <label class="arp-dropzone" [class.arp-dropzone--full]="evidenceFiles.length >= 5">
                <input type="file" multiple accept="image/*,.pdf,.doc,.docx"
                  style="display:none" (change)="onFilesChange($event)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke-linecap="round"/>
                </svg>
                <span class="arp-dropzone__label">{{ 'plainte_preuves_deposer' | translate }}</span>
                <span class="arp-dropzone__hint">{{ 'commun_fichiers_hint' | translate }}</span>
              </label>

              <span *ngIf="evidenceError" class="arp-err d-block mt-2">{{ evidenceError }}</span>

              <div *ngIf="evidenceFiles.length > 0" class="arp-file-list">
                <div *ngFor="let f of evidenceFiles; let i = index" class="arp-file-item">
                  <div class="arp-file-icon">
                    <svg *ngIf="fileIsImage(f)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3">
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <path d="M21 15l-5-5L5 21" stroke-linecap="round"/>
                    </svg>
                    <svg *ngIf="!fileIsImage(f)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke-linecap="round"/>
                    </svg>
                  </div>
                  <div class="arp-file-meta">
                    <span class="arp-file-name">{{ f.name }}</span>
                    <span class="arp-file-size">{{ formatSize(f.size) }}</span>
                  </div>
                  <button type="button" class="arp-file-del" (click)="removeFile(i)">
                    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4">
                      <path d="M4 4l8 8M12 4l-8 8" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <!-- Captcha anti-spam -->
            <div class="arp-form__section">
              <app-captcha #captcha [(value)]="captchaAnswer"></app-captcha>
            </div>

            <!-- Actions -->
            <div class="arp-form__actions">
              <button type="button" class="careox-btn careox-btn--ghost" (click)="reset()">
                <span>{{ 'plainte_annuler' | translate }}</span>
              </button>
              <button type="submit" class="careox-btn" [disabled]="loading">
                <span *ngIf="loading" class="arp-spinner"></span>
                <span>{{ loading ? ('plainte_envoi' | translate) : ('plainte_envoyer' | translate) }}</span>
              </button>
            </div>

          </form>
        </div>

      </div>
    </div>
  </div>
</section>
